import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../ConditionRegistryItem';
export class ConditionRegistryContext extends ConditionRegistryCategory {
    label = 'Context';
    constructor(parent) {
        super(parent);
        super.init();
    }
    switched = () => new ConditionRegistryItem({
        eval: ({ evaluator, at }) => {
            if (!evaluator.traitCondition)
                return false;
            const switchName = evaluator.traitCondition.local.valueOf.switchName;
            const compareValue = evaluator.traitCondition.local.valueOf.switchValue; // || evaluator.traitCondition.local.valueOf[switchName];
            if (at.trait.aspect.context.question && at.trait.aspect.context.question.context.contextSignals.signalValueOf(switchName)) {
                return at.trait.aspect.context.question.context.contextSignals.signalValueOf(switchName) === compareValue;
            }
            return at.trait.aspect.actor.context.contextSignals.signalValueOf(switchName) === compareValue;
        },
    });
}
